module.exports = __webpack_public_path__ + "static/media/createPaymentLink.420bc7ff.svg";